import { ToastProgrammatic as Toast } from 'buefy';

import Vue from 'vue';
import Router from 'vue-router';

import routes from './routes';

import store from '../store';

const NEED_COMPANY_MESSAGE = {
  type: 'is-warning',
  message: 'Necesitas completar la infomación de tu compañia.',
  duration: 5000,
  position: 'is-top',
};

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

async function validateSession(to, from, next) {
  try {
    await store.dispatch('auth/initAuthentication');

    next();
  } catch (error) {
    next({ name: 'SignIn', query: { redirect: to.path } });
  }
}

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(route => route.meta.auth);

  const { signed, companyId } = store.state.auth;

  const hasCompany = companyId > 0 || !!companyId;

  if (to.name === 'SignOut') return next();

  if (!hasCompany && signed) {
    if (to.name === 'Company') return next();

    Toast.open(NEED_COMPANY_MESSAGE);
    return next({ name: 'Company' });
  }
  if (requiresAuth && !signed) return validateSession(to, from, next);

  return next();
});

router.afterEach(() => {
  if (typeof window.inline_manual_player !== 'undefined') {
    window.inline_manual_player.update();
  }
});

export default router;
